var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentReceived(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
    fill: "#E5FAF2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17498_290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1334 9.33333C15.0007 8.95683 14.7584 8.62864 14.4376 8.39102C14.1168 8.1534 13.7323 8.01722 13.3334 8H10.6667C10.1363 8 9.62761 8.21071 9.25253 8.58579C8.87746 8.96086 8.66675 9.46957 8.66675 10C8.66675 10.5304 8.87746 11.0391 9.25253 11.4142C9.62761 11.7893 10.1363 12 10.6667 12H13.3334C13.8638 12 14.3726 12.2107 14.7476 12.5858C15.1227 12.9609 15.3334 13.4696 15.3334 14C15.3334 14.5304 15.1227 15.0391 14.7476 15.4142C14.3726 15.7893 13.8638 16 13.3334 16H10.6667C10.2679 15.9828 9.88335 15.8466 9.56257 15.609C9.24178 15.3714 8.99945 15.0432 8.86675 14.6667",
    stroke: "#50B793",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6V8M12 16V18",
    stroke: "#50B793",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17498_290"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentReceived);
export default __webpack_public_path__ + "static/media/payment_received.c7c19226e9383e80cec838a0315e62a1.svg";
export { ForwardRef as ReactComponent };